import { colors } from '@lmc/common/constants'
import { Icon } from '@lmc/ui-kit'
import { Menu } from 'antd'
import { useState } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import AntdDropdown from '../AntdDropdown/AntdDropdown'

const isDesktop = isBrowser || isTablet

type MenuItem = { label: string; url?: string }

type LabelProps = {
  isActive?: boolean
  labelTitle?: string
  mobileIcon?: string
  open: boolean
  setOpen: (open: boolean) => void
}

type TabBarDropdownProps = {
  baseUrl?: string
  dropdownPlacement?: string
  isActive?: boolean
  labelTitle?: string
  menuItems: MenuItem[]
  mobileIcon?: string
}

const Label = ({
  isActive,
  labelTitle,
  mobileIcon,
  open,
  setOpen
}: LabelProps) => {
  const iconName = open ? 'UpOutlined' : 'DownOutlined'

  const mobileIconStyle = { ...(isActive && { color: colors.pink }) }

  return (
    <LabelDiv onClick={() => setOpen(!open)}>
      {isDesktop || !mobileIcon ? (
        <div>{labelTitle}</div>
      ) : (
        <Icon name={mobileIcon} style={mobileIconStyle} />
      )}
      <Icon name={iconName} style={{ marginLeft: 8 }} />
    </LabelDiv>
  )
}

const handleSelect = ({
  open,
  setOpen
}: {
  open: boolean
  setOpen: (open: boolean) => void
}) => {
  setOpen(!open)
}

export default function TabBarDropdown({
  baseUrl,
  dropdownPlacement,
  isActive,
  labelTitle,
  menuItems,
  mobileIcon
}: TabBarDropdownProps) {
  const [open, setOpen] = useState(false)

  return (
    <ContainerDiv $isActive={isActive}>
      <AntdDropdown
        label={
          <Label
            isActive={isActive}
            labelTitle={labelTitle}
            mobileIcon={mobileIcon}
            open={open}
            setOpen={setOpen}
          />
        }
        onOpenChange={() => setOpen(!open)}
        placement={dropdownPlacement}
        trigger="click"
      >
        <MenuStyled onClick={() => handleSelect({ open, setOpen })}>
          {menuItems.map((item) => {
            return (
              <Menu.Item key={item.label}>
                <StyledLink
                  to={item.url ? `${baseUrl}/${item.url}` : (baseUrl ?? '')}
                >
                  {item.label}
                </StyledLink>
              </Menu.Item>
            )
          })}
        </MenuStyled>
      </AntdDropdown>
    </ContainerDiv>
  )
}

const ContainerDiv = styled.div<{ $isActive?: boolean }>`
  align-items: center;
  border-bottom: 3px solid ${({ $isActive }) => ($isActive ? colors.pink : 'transparent')};
  display: flex;
`

const LabelDiv = styled.div`
  align-items: center;
  display: flex;
  padding: 0.75em 1em 0.65em;
  &:hover {
    cursor: pointer;
    color: ${colors.pink};
  }
`

const MenuStyled = styled(Menu)`
  box-shadow: 0 1px 3px hsla(0, 0%, 0%, 0.1), 0 -1px 3px hsla(0, 0%, 0%, 0.1);
`

const StyledLink = styled(Link)`
  text-decoration: none;
`
